import {
  ISpotlightCollection,
  IMediaImageCard,
  IMediaSnippet
} from '@pcln/contentful-components'
import analytics from '@/shared-utils/analytics'

function isMediaImageCard(
  content: IMediaImageCard | IMediaSnippet
): content is IMediaImageCard {
  return content.contentTypeId === 'mediaImageCard'
}

function generateMediaCards(
  mediaCards: Array<IMediaImageCard | IMediaSnippet>
) {
  return mediaCards.map(mediaCard => {
    if (isMediaImageCard(mediaCard)) {
      const { callToAction, backgroundImage } = mediaCard
      return {
        ...mediaCard,
        backgroundImageUrl: backgroundImage?.file?.url,
        callToAction: {
          contentTypeId: callToAction?.label ? 'button' : '',
          openInNewTab: callToAction?.openInNewTab,
          url: callToAction?.url || '',
          buttonText: callToAction?.label,
          label: callToAction?.label || '',
          onClick: () => {
            const tracking = callToAction?.analyticsTracking
            if (tracking) {
              analytics.fireEvent({
                category: tracking.category,
                action: tracking.action,
                label: tracking.label
              })
            }
          },
          ariaLabel: callToAction?.ariaLabel || ''
        },
        contentAlign: mediaCard.contentAlign || 'default',
        logoImageUrl: mediaCard.logoImage?.file.url,
        logoImageAlt: mediaCard.logoImage?.title,
        showBorder: mediaCard.showBorder || false
      }
    }

    return {
      ...mediaCard
    }
  })
}
export default function mapSpotlightCollectionContentfulData(
  data: ISpotlightCollection
) {
  const {
    logoImage,
    heading,
    headingColor,
    subheading,
    subheadingColor,
    callToAction,
    backgroundColor,
    spotlightColor,
    mediaCards = []
  } = data

  const filteredMediaCards = mediaCards.filter(
    mediaCard => mediaCard.contentTypeId !== undefined
  )
  return {
    primaryLogoImageUrl: logoImage?.asset.file.url,
    primaryLogoImageAlt: logoImage?.altText,
    primaryHeading: heading,
    primaryHeadingColor: headingColor,
    primarySubheading: subheading,
    primarySubheadingColor: subheadingColor,
    backgroundColor,
    spotlightColor,
    callToAction: {
      url: callToAction?.url,
      buttonText: callToAction?.label,
      ariaLabel: callToAction?.ariaLabel,
      googleAnalyticsTracking: {
        label: callToAction?.analyticsTracking?.label,
        action: callToAction?.analyticsTracking?.action,
        category: callToAction?.analyticsTracking?.category
      },
      color: callToAction?.color
    },
    mediaCards: generateMediaCards(filteredMediaCards)
  }
}
